import { Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useClientesColumns from "./useClientesColumns";

export default function Lista() {
  const { clientesColumns } = useClientesColumns();
  const { clientes } = useSelector((state) => state.clientesReducer);

  const [listaFinal, setListaFinal] = useState([]);

  useEffect(() => {
    setListaFinal(clientes);
  }, [clientes]);

  const filter = ({ target }) => {
    if (target.value !== "") {
      var newList = clientes.filter(
        (a) =>
          (a.nombre &&
            a.nombre.toLowerCase().includes(target.value.toLowerCase())) ||
          (a.contactoNombre &&
            a.contactoNombre
              .toLowerCase()
              .includes(target.value.toLowerCase())) ||
          (a.contactoEmail &&
            a.contactoEmail.toLowerCase().includes(target.value.toLowerCase()))
      );
      setListaFinal(newList);
    } else {
      setListaFinal(clientes);
    }
  };

  return (
    <>
      <Input
        onChange={filter}
        placeholder="buscar"
        style={{ width: 300, marginBottom: 10 }}
      />
      <Table
        rowKey="clienteID"
        columns={clientesColumns}
        dataSource={listaFinal}
      />
    </>
  );
}
